export default {
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [// 运营管理-机构用户-机构管理
  {
    path: 'operateOrgList',
    name: 'operateOrgList',
    meta: {
      title: '机构管理',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['operateOrgList']
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateOrgList/operateOrgList');
    }
  }, // 运营管理-机构用户-机构管理-机构授权
  {
    path: 'operateOrgAuthorize',
    name: 'operateOrgAuthorize',
    meta: {
      title: '机构授权',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateOrgList/operateOrgAuthorize');
    }
  }, // 运营管理-机构用户-机构管理-机构新增
  {
    path: 'operateOrgAdd',
    name: 'operateOrgAdd',
    meta: {
      title: '新增组织机构',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateOrgList/operateOrgAdd');
    }
  }, // 运营管理-机构用户-机构管理-修改
  {
    path: 'operateOrgEdit',
    name: 'operateOrgEdit',
    meta: {
      title: '修改组织机构',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateOrgList/operateOrgEdit');
    }
  }, // 运营管理-机构用户-机构管理-详情
  {
    path: 'operateOrgDetail',
    name: 'operateOrgDetail',
    meta: {
      title: '组织机构详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateOrgList/operateOrgDetail');
    }
  }, // 运营管理-机构用户-管理员管理
  {
    path: 'operateManagerList',
    name: 'operateManagerList',
    meta: {
      title: '管理员管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['operateManagerList']
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateManagerList/operateManagerList');
    }
  }, // 运营管理-机构用户-管理员管理-新增
  {
    path: 'operateManagerAdd',
    name: 'operateManagerAdd',
    meta: {
      title: '管理员管理新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateManagerList/operateManagerAdd');
    }
  }, // 运营管理-机构用户-管理员管理-发布岗位
  {
    path: 'operateManagerPost',
    name: 'operateManagerPost',
    meta: {
      title: '发布岗位',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateManagerList/operateManagerPost');
    }
  }, // 运营管理-机构用户-管理员管理-发布资源
  {
    path: 'operateManagerSource',
    name: 'operateManagerSource',
    meta: {
      title: '发布资源',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateManagerList/operateManagerSource');
    }
  }, // 运营管理-机构用户-内部企业用户管理
  {
    path: 'operateUserList',
    name: 'operateUserList',
    meta: {
      title: '内部企业用户管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['operateUserList']
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateUserList/operateUserList');
    }
  }, // 运营管理-机构用户-客商企业用户管理
  {
    path: 'merchantUserList',
    name: 'merchantUserList',
    meta: {
      title: '客商企业用户管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['merchantUserList']
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/merchantUserList/merchantUserList');
    }
  }, // 运营管理-机构用户-客商企业用户管理-详情
  {
    path: 'merchantUserDetail',
    name: 'merchantUserDetail',
    meta: {
      title: '查看用户信息详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/merchantUserList/merchantUserDetail');
    }
  }, // 运营管理-机构用户-客商企业用户管理-修改
  {
    path: 'merchantUserEdit',
    name: 'merchantUserEdit',
    meta: {
      title: '修改用户',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/merchantUserList/merchantUserEdit');
    }
  }, // 运营管理-机构用户-客商企业用户管理-新增
  {
    path: 'merchantUserAdd',
    name: 'merchantUserAdd',
    meta: {
      title: '新增用户',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/merchantUserList/merchantUserAdd');
    }
  }, // 运营管理-机构用户-客商基本信息管理
  {
    path: 'merchantBasicList',
    name: 'merchantBasicList',
    meta: {
      title: '客商基本信息管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['merchantBasicList']
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/merchantBasicList/merchantBasicList');
    }
  }, // 运营管理-机构用户-客商基本信息管理-详情
  {
    path: 'merchantBasicDetail',
    name: 'merchantBasicDetail',
    meta: {
      title: '内部供应商详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/merchantBasicList/merchantBasicDetail');
    }
  }, // 运营管理-机构用户-客商基本信息管理-新增
  {
    path: 'merchantBasicAdd',
    name: 'merchantBasicAdd',
    meta: {
      title: '新增内部供应商',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/merchantBasicList/merchantBasicAdd');
    }
  }, // 运营管理-机构用户-客商基本信息管理-修改
  {
    path: 'merchantBasicEdit',
    name: 'merchantBasicEdit',
    meta: {
      title: '修改内部供应商',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/merchantBasicList/merchantBasicEdit');
    }
  }, // 运营管理-机构用户-用户管理-内部企业-新增
  {
    path: 'innerEnterPriseAdd',
    name: 'innerEnterPriseAdd',
    meta: {
      title: '内部企业用户新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateUserList/innerEnterprise/innerEnterPriseAdd');
    }
  }, // 运营管理-机构用户-用户管理-内部企业-修改
  {
    path: 'innerEnterPriseEdit',
    name: 'innerEnterPriseEdit',
    meta: {
      title: '内部企业用户修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateUserList/innerEnterprise/innerEnterPriseEdit');
    }
  }, // 运营管理-机构用户-用户管理-内部企业-调岗兼职
  {
    path: 'innerEnterPriseTransfer',
    name: 'innerEnterPriseTransfer',
    meta: {
      title: '内部企业用户调岗兼职',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateUserList/innerEnterprise/innerEnterPriseTransfer');
    }
  }, // 运营管理-机构用户-用户管理-内部企业-详情
  {
    path: 'innerEnterPriseDetail',
    name: 'innerEnterPriseDetail',
    meta: {
      title: '内部企业用户详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateUserList/innerEnterprise/innerEnterPriseDetail');
    }
  }, // 运营管理-机构用户-用户管理-外部企业-修改
  {
    path: 'outerEnterpriseEdit',
    name: 'outerEnterpriseEdit',
    meta: {
      title: '客商企业用户修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateUserList/outerEnterprise/outerEnterpriseEdit');
    }
  }, // 运营管理-机构用户-用户管理-外部企业-调岗
  {
    path: 'outerEnterpriseTransfer',
    name: 'outerEnterpriseTransfer',
    meta: {
      title: '客商企业用户调岗',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateUserList/outerEnterprise/outerEnterpriseTransfer');
    }
  }, // 运营管理-机构用户-用户管理-外部企业-详情
  {
    path: 'outerEnterpriseDetail',
    name: 'outerEnterpriseDetail',
    meta: {
      title: '客商企业用户详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateUserList/outerEnterprise/outerEnterpriseDetail');
    }
  }, // 运营管理-机构用户-用户管理-外部个人-修改
  {
    path: 'outerIndividualsEdit',
    name: 'outerIndividualsEdit',
    meta: {
      title: '外部个人用户修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateUserList/outerIndividuals/outerIndividualsEdit');
    }
  }, // 运营管理-机构用户-用户管理-外部个人-详情
  {
    path: 'outerIndividualsDetail',
    name: 'outerIndividualsDetail',
    meta: {
      title: '外部个人用户详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/operateUserList/outerIndividuals/outerIndividualsDetail');
    }
  }, // 运营管理-角色权限-角色管理
  {
    path: 'roleList',
    name: 'roleList',
    meta: {
      title: '角色管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['roleList']
    },
    component: function component() {
      return import('@/pages/operateModule/roleAuthorityMenu/roleList/roleList');
    }
  }, // 运营管理-角色权限-角色管理 分配岗位组
  {
    path: 'roleAssignJobs',
    name: 'roleAssignJobs',
    meta: {
      title: '分配岗位组',
      hidden: true // isCheckMenu: true,
      // belongMenus: ['roleList']

    },
    component: function component() {
      return import('@/pages/operateModule/roleAuthorityMenu/roleList/roleAssignJobs');
    }
  }, // 运营管理-角色权限-角色管理-授权
  {
    path: 'roleAuthority',
    name: 'roleAuthority',
    meta: {
      title: '用户授权',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/roleAuthorityMenu/roleList/roleAuthority');
    }
  }, // 运营管理-角色权限-角色管理-配置
  {
    path: 'roleAuthorityConfig',
    name: 'roleAuthorityConfig',
    meta: {
      title: '配置',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/roleAuthorityMenu/roleList/roleAuthorityConfig');
    }
  }, // 运营管理-角色权限-角色管理-配置
  {
    path: 'roleConfig',
    name: 'roleConfig',
    meta: {
      title: '角色管理-配置',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/roleAuthorityMenu/roleList/roleConfig');
    }
  }, // 运营管理-角色权限-角色管理-发布资源
  {
    path: 'roleResource',
    name: 'roleResource',
    meta: {
      title: '角色管理-发布资源',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/roleAuthorityMenu/roleList/roleResource');
    }
  }, // 运营管理-角色权限-角色管理-角色详情
  {
    path: 'roleDetail',
    name: 'roleDetail',
    meta: {
      title: '角色详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/roleAuthorityMenu/roleList/roleDetail');
    }
  }, // 运营管理-入驻管理-供应商签约管理
  {
    path: 'supContractList',
    name: 'supContractList',
    meta: {
      title: '供应商签约管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supContractList']
    },
    component: function component() {
      return import('@/pages/operateModule/settleMenu/supContractList/supContractList');
    }
  }, // 运营管理-入驻管理-供应商签约管理-办理
  {
    path: 'supContrac',
    name: 'supContrac',
    meta: {
      title: '办理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/settleMenu/supContractList/supContrac');
    }
  }, // 运营管理-计费管理-成交服务费
  {
    path: 'dealServiceList',
    name: 'dealServiceList',
    meta: {
      cache: true,
      title: '成交服务费',
      isCheckMenu: true,
      belongMenus: ['dealServiceList'] // hidden: true

    },
    component: function component() {
      return import('@/pages/operateModule/chargeMenu/dealServiceList/dealServiceList');
    }
  }, // 运营管理-计费管理-成交服务费结算单详情
  {
    path: 'dealServiceDetailInfo',
    name: 'dealServiceDetailInfo',
    meta: {
      title: '成交服务费结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/chargeMenu/dealServiceList/dealServiceDetailInfo');
    }
  }, // 运营管理-计费管理-成交服务费提交
  {
    path: 'dealServiceConfirm',
    name: 'dealServiceConfirm',
    meta: {
      title: '成交服务费结算单',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/chargeMenu/dealServiceList/dealServiceConfirm');
    }
  }, // 运营管理-运营管理审批-成交服务费优惠减免审批列表
  {
    path: 'dealServiceApproveList',
    name: 'dealServiceApproveList',
    meta: {
      title: '成交服务费减免审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['dealServiceApproveList']
    },
    component: function component() {
      return import('@/pages/operateModule/manageApproveMenu/dealServiceApprove/dealServiceApproveList');
    }
  }, // 运营管理-运营管理审批-成交服务费优惠减免详情页
  {
    path: 'dealServiceApproveDetail',
    name: 'dealServiceApproveDetail',
    meta: {
      title: '减免审批详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/manageApproveMenu/dealServiceApprove/dealServiceApproveDetail');
    }
  }, // 运营管理-运营管理审批-成交服务费优惠减免审批页面
  {
    path: 'dealServiceApprove',
    name: 'dealServiceApprove',
    meta: {
      title: '减免审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/manageApproveMenu/dealServiceApprove/dealServiceApprove');
    }
  }, // 运营管理-计费管理-平台使用费优惠减免审批列表
  {
    path: 'platformRoyaltyApproveList',
    name: 'platformRoyaltyApproveList',
    meta: {
      title: '平台使用费减免审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['platformRoyaltyApproveList']
    },
    component: function component() {
      return import('@/pages/operateModule/manageApproveMenu/platformRoyaltyApprove/platformRoyaltyApproveList');
    }
  }, // 运营管理-运营管理审批-平台使用费优惠减免详情页
  {
    path: 'platformRoyaltyApproveDetail',
    name: 'platformRoyaltyApproveDetail',
    meta: {
      title: '减免审批详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/manageApproveMenu/platformRoyaltyApprove/platformRoyaltyApproveDetail');
    }
  }, // 运营管理-运营管理审批-平台使用费优惠减免审批页面
  {
    path: 'platformRoyaltyApprove',
    name: 'platformRoyaltyApprove',
    meta: {
      title: '减免审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/manageApproveMenu/platformRoyaltyApprove/platformRoyaltyApprove');
    }
  }, // 运营管理-运营管理审批-客商基本信息审批列表
  {
    path: 'merchantsBaseInfoApproveList',
    name: 'merchantsBaseInfoApproveList',
    meta: {
      title: '客商基本信息审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['merchantsBaseInfoApproveList']
    },
    component: function component() {
      return import('@/pages/operateModule/manageApproveMenu/merchantsBaseInfoApprove/merchantsBaseInfoApproveList');
    }
  }, // 运营管理-运营管理审批-客商基本信息审批页面
  {
    path: 'merchantsBaseInfoApprove',
    name: 'merchantsBaseInfoApprove',
    meta: {
      title: '客商基本信息审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/manageApproveMenu/merchantsBaseInfoApprove/merchantsBaseInfoApprove');
    }
  }, // 运营管理-运营管理审批-客商基本信息详情
  {
    path: 'merchantsBaseInfoApproveDetail',
    name: 'merchantsBaseInfoApproveDetail',
    meta: {
      title: '客商基本信息详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/manageApproveMenu/merchantsBaseInfoApprove/merchantsBaseInfoApproveDetail');
    }
  }, // 运营管理-计费管理-平台使用费
  {
    path: 'platformRoyaltyList',
    name: 'platformRoyaltyList',
    meta: {
      title: '平台使用费',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['platformRoyaltyList']
    },
    component: function component() {
      return import('@/pages/operateModule/chargeMenu/platformRoyaltyList/platformRoyaltyList');
    }
  }, // 运营管理-计费管理-运费管理
  {
    path: 'freightManagement',
    name: 'freightManagement',
    meta: {
      title: '运费管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['freightManagement']
    },
    component: function component() {
      return import('@/pages/operateModule/chargeMenu/freightManagement/freightManagement');
    }
  }, // 运营管理-计费管理-运费管理新增
  {
    path: 'freightAdd',
    name: 'freightAdd',
    meta: {
      title: '运费管理',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/chargeMenu/freightManagement/freightAdd');
    }
  }, // 运营管理-计费管理-平台使用费结算单详情
  {
    path: 'platformRoyaltyDetailInfo',
    name: 'platformRoyaltyDetailInfo',
    meta: {
      title: '平台使用费',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/chargeMenu/platformRoyaltyList/platformRoyaltyDetailInfo');
    }
  }, // 运营管理-基础数据设置-金额计量单位
  {
    path: 'amountUnitSetting',
    name: 'amountUnitSetting',
    meta: {
      title: '金额计量单位',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['amountUnitSetting']
    },
    component: function component() {
      return import('@/pages/operateModule/opeBaseDataSetMenu/amountUnitSetting/amountUnitSetting');
    }
  }, // 运营管理-基础数据设置-基础货币
  {
    path: 'basicCurrencySetting',
    name: 'basicCurrencySetting',
    meta: {
      title: '基础货币',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['basicCurrencySetting']
    },
    component: function component() {
      return import('@/pages/operateModule/opeBaseDataSetMenu/basicCurrencySetting/basicCurrencySetting');
    }
  }, // 运营管理-基础数据设置-商品搜索结果综合排序条件
  {
    path: 'goodsSearchSortSetting',
    name: 'goodsSearchSortSetting',
    meta: {
      title: '综合排序条件',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['goodsSearchSortSetting']
    },
    component: function component() {
      return import('@/pages/operateModule/opeBaseDataSetMenu/goodsSearchSortSetting/goodsSearchSortSetting');
    }
  }, // 运营管理-基础数据设置-数量计量单位
  {
    path: 'quantityUnitSetting',
    name: 'quantityUnitSetting',
    meta: {
      title: '数量计量单位',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['quantityUnitSetting']
    },
    component: function component() {
      return import('@/pages/operateModule/opeBaseDataSetMenu/quantityUnitSetting/quantityUnitSetting');
    }
  }, // 运营管理-基础数据设置-推荐搜索词
  {
    path: 'recommendedWordSetting',
    name: 'recommendedWordSetting',
    meta: {
      title: '推荐搜索词',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['recommendedWordSetting']
    },
    component: function component() {
      return import('@/pages/operateModule/opeBaseDataSetMenu/recommendedWordSetting/recommendedWordSetting');
    }
  }, // 运营管理-基础数据设置-敏感词
  {
    path: 'sensitiveWordsSetting',
    name: 'sensitiveWordsSetting',
    meta: {
      title: '敏感词',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['sensitiveWordsSetting']
    },
    component: function component() {
      return import('@/pages/operateModule/opeBaseDataSetMenu/sensitiveWordsSetting/sensitiveWordsSetting');
    }
  }, // 运营管理-参数设置-运营管理参数
  {
    path: 'operateManageParam',
    name: 'operateManageParam',
    meta: {
      title: '运营管理参数',
      isCheckMenu: true,
      belongMenus: ['operateManageParam']
    },
    component: function component() {
      return import('@/pages/operateModule/parameterMenu/parameterDefaultList/operateManageParam');
    }
  }, // 运营管理-参数设置-系统基础货币设置-修改
  {
    path: 'systemBaseCurrencyEdit',
    name: 'systemBaseCurrencyEdit',
    meta: {
      title: '系统基础货币设置-修改设置',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/parameterMenu/systemBaseCurrencyList/systemBaseCurrencyEdit');
    }
  }, // 运营管理-参数设置-平台服务费违约限制规则-修改
  {
    path: 'platformFeeLimitRulesEdit',
    name: 'platformFeeLimitRulesEdit',
    meta: {
      title: '平台服务费违约限制规则-修改设置',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/parameterMenu/platformFeeLimitRulesList/platformFeeLimitRulesEdit');
    }
  }, // 运营管理-参数设置-平台服务费违约限制规则-添加例外
  {
    path: 'platformFeeLimitRulesAdd',
    name: 'platformFeeLimitRulesAdd',
    meta: {
      title: '平台服务费违约限制规则-添加例外',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/parameterMenu/platformFeeLimitRulesList/platformFeeLimitRulesAdd');
    }
  }, // 运营管理-参数设置-成交服务费违约限制规则-修改
  {
    path: 'dealFeeLimitRulesEdit',
    name: 'dealFeeLimitRulesEdit',
    meta: {
      title: '成交服务费违约限制规则-修改设置',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/parameterMenu/dealFeeLimitRulesList/dealFeeLimitRulesEdit');
    }
  }, // 运营管理-参数设置-成交服务费违约限制规则-添加例外
  {
    path: 'dealFeeLimitRulesAdd',
    name: 'dealFeeLimitRulesAdd',
    meta: {
      title: '成交服务费违约限制规则-添加例外',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/parameterMenu/dealFeeLimitRulesList/dealFeeLimitRulesAdd');
    }
  }, // 运营管理-参数设置-平台使用费业务费用收取规则-修改
  {
    path: 'platformFeeCollectionRulesEdit',
    name: 'platformFeeCollectionRulesEdit',
    meta: {
      title: '平台使用费业务费用收取规则-修改设置',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/parameterMenu/platformFeeCollectionRulesList/platformFeeCollectionRulesEdit');
    }
  }, // 运营管理-参数设置-平台使用费业务费用收取规则-添加例外
  {
    path: 'platformFeeCollectionRulesAdd',
    name: 'platformFeeCollectionRulesAdd',
    meta: {
      title: '平台使用费业务费用收取规则-添加例外',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/parameterMenu/platformFeeCollectionRulesList/platformFeeCollectionRulesAdd');
    }
  }, // 运营管理-参数设置-结算参数 修改
  {
    path: 'settlementParameterList',
    name: 'settlementParameterList',
    meta: {
      title: '结算参数',
      isCheckMenu: true,
      belongMenus: ['settlementParameterList']
    },
    component: function component() {
      return import('@/pages/operateModule/parameterMenu/settlementParameterList/settlementParameterList');
    }
  }, // 运营管理-参数设置-结算参数 修改
  {
    path: 'settlementParameterEdit',
    name: 'settlementParameterEdit',
    meta: {
      title: '结算参数-修改设置',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/parameterMenu/settlementParameterList/settlementParameterEdit');
    }
  }, // 运营管理-参数设置-成交服务费业务费用收取规则-修改
  {
    path: 'dealFeeCollectionRulesEdit',
    name: 'dealFeeCollectionRulesEdit',
    meta: {
      title: '成交服务费业务费用收取规则-修改设置',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/parameterMenu/dealFeeCollectionRulesList/dealFeeCollectionRulesEdit');
    }
  }, // 运营管理-参数设置-成交服务费业务费用收取规则-添加例外
  {
    path: 'dealFeeCollectionRulesAdd',
    name: 'dealFeeCollectionRulesAdd',
    meta: {
      title: '成交服务费业务费用收取规则-添加例外',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/parameterMenu/dealFeeCollectionRulesList/dealFeeCollectionRulesAdd');
    }
  }, // 运营管理-智能客服管理-客服管理
  {
    path: 'opeCustomerServiceManage',
    name: 'opeCustomerServiceManage',
    meta: {
      title: '客服管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['opeCustomerServiceManage']
    },
    component: function component() {
      return import('@/pages/operateModule/opeCustomerServiceMenu/opeCustomerServiceManage/opeCustomerServiceManage');
    }
  }, // 运营管理-智能客服管理-客服管理-新增
  {
    path: 'opeCustomerServiceAdd',
    name: 'opeCustomerServiceAdd',
    meta: {
      title: '客服管理新增',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/opeCustomerServiceMenu/opeCustomerServiceManage/opeCustomerServiceAdd');
    }
  }, // 运营管理-智能客服管理-客服管理-修改
  {
    path: 'opeCustomerServiceEdit',
    name: 'opeCustomerServiceEdit',
    meta: {
      title: '客服管理修改',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/opeCustomerServiceMenu/opeCustomerServiceManage/opeCustomerServiceEdit');
    }
  }, //  ===========通知中心 start===============
  // 运营管理-通知管理-通知分类管理
  {
    path: 'noticeClassifyList',
    name: 'noticeClassifyList',
    meta: {
      title: '通知分类管理',
      isCheckMenu: true,
      belongMenus: ['noticeClassifyList'] // cache: true
      // hidden: true

    },
    component: function component() {
      return import('@/pages/operateModule/noticeMenu/noticeClassifyList/noticeClassifyList');
    }
  }, // 运营管理-通知管理-业务变量管理
  {
    path: 'busiVarList',
    name: 'busiVarList',
    meta: {
      title: '业务变量管理',
      isCheckMenu: true,
      belongMenus: ['busiVarList'] // cache: true
      // hidden: true

    },
    component: function component() {
      return import('@/pages/operateModule/noticeMenu/busiVarList/busiVarList');
    }
  }, // 运营管理-通知管理-通知模板
  {
    path: 'noticeTemplateList',
    name: 'noticeTemplateList',
    meta: {
      title: '通知模板',
      isCheckMenu: true,
      belongMenus: ['noticeTemplateList'] // cache: true
      // hidden: true

    },
    component: function component() {
      return import('@/pages/operateModule/noticeMenu/noticeTemplateList/noticeTemplateList');
    }
  }, // 运营管理-通知管理-通知任务管理
  {
    path: 'noticeTaskList',
    name: 'noticeTaskList',
    meta: {
      title: '通知任务管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['noticeTaskList'] // hidden: true

    },
    component: function component() {
      return import('@/pages/operateModule/noticeMenu/noticeTaskList/noticeTaskList');
    }
  }, // 运营管理-通知管理-通知任务管理-新增任务
  {
    path: 'noticeTaskAdd',
    name: 'noticeTaskAdd',
    meta: {
      title: '新增通知任务',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/noticeMenu/noticeTaskList/noticeTaskAdd');
    }
  }, // 运营管理-通知管理-通知任务管理-查看任务-任务名称查看
  {
    path: 'noticeTaskDetailByName',
    name: 'noticeTaskDetailByName',
    meta: {
      title: '查看任务',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/noticeMenu/noticeTaskList/noticeTaskDetailByName');
    }
  }, // 运营管理-通知管理-通知任务管理-查看任务详情-操作查看
  {
    path: 'noticeTaskDetailByButton',
    name: 'noticeTaskDetailByButton',
    meta: {
      title: '查看任务详情',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/noticeMenu/noticeTaskList/noticeTaskDetailByButton');
    }
  }, // 运营管理-通知管理-通知任务管理-修改任务
  {
    path: 'noticeTaskEdit',
    name: 'noticeTaskEdit',
    meta: {
      title: '修改通知任务',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/noticeMenu/noticeTaskEdit/noticeTaskEdit');
    }
  }, //  ===========通知中心 end===============
  //  ===========预算管理 begin===============
  // 运营管理 - 预算管理 - 采购限额管理列表
  {
    path: 'procurementLimitList',
    name: 'procurementLimitList',
    meta: {
      title: '采购限额管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['procurementLimitList']
    },
    component: function component() {
      return import('@/pages/operateModule/budgetMenu/procurementLimitList/procurementLimitList');
    }
  }, // 运营管理 - 预算管理 - 采购限额管理 历史记录
  {
    path: 'procurementLimitHistory',
    name: 'procurementLimitHistory',
    meta: {
      title: '采购限额管理历史记录',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/budgetMenu/procurementLimitList/procurementLimitHistory');
    }
  }, // 运营管理 - 预算管理 - 采购限额管理 新增
  {
    path: 'procurementLimitAdd',
    name: 'procurementLimitAdd',
    meta: {
      title: '采购限额管理新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/budgetMenu/procurementLimitList/procurementLimitAdd');
    }
  }, // 运营管理 - 预算管理 - 采购限额管理 修改
  {
    path: 'procurementLimitEdit',
    name: 'procurementLimitEdit',
    meta: {
      title: '采购限额管理修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/budgetMenu/procurementLimitList/procurementLimitEdit');
    }
  }, // 运营管理 - 预算管理 - 采购限额管理 修改
  {
    path: 'opeCsOnlineWorkbench',
    name: 'opeCsOnlineWorkbench',
    meta: {
      title: '在线工作台',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/opeCustomerServiceMenu/opeCsOnlineWorkbench.vue');
    }
  }, // 运营管理 - 预算管理 - 授信管理列表
  {
    path: 'creditExtensionList',
    name: 'creditExtensionList',
    meta: {
      title: '授信管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['creditExtensionList']
    },
    component: function component() {
      return import('@/pages/operateModule/budgetMenu/creditExtensionList/creditExtensionList');
    }
  }, // 运营管理 - 预算管理 - 授信管理列表 - 新增授信
  {
    path: 'newCreditExtension',
    name: 'newCreditExtension',
    meta: {
      title: '新增授信',
      hidden: true,
      isCheckMenu: true,
      belongMenus: ['creditExtensionList']
    },
    component: function component() {
      return import('@/pages/operateModule/budgetMenu/newCreditExtension/newCreditExtension.vue');
    }
  }, // 运营管理 - 预算管理 - 授信申请管理列表
  {
    path: 'creditExtensionApplyList',
    name: 'creditExtensionApplyList',
    meta: {
      title: '授信申请管理',
      hidden: true,
      isCheckMenu: true,
      belongMenus: ['creditExtensionList']
    },
    component: function component() {
      return import('@/pages/operateModule/budgetMenu/creditExtensionApplyList/creditExtensionApplyList');
    }
  }, // 运营管理 - 预算管理 - 授信管理 历史记录
  {
    path: 'creditExtensionHistory',
    name: 'creditExtensionHistory',
    meta: {
      title: '采购限额管理历史记录',
      hidden: true,
      isCheckMenu: true,
      belongMenus: ['creditExtensionList']
    },
    component: function component() {
      return import('@/pages/operateModule/budgetMenu/creditExtensionList/creditExtensionHistory');
    }
  }, // 运营管理 - 预算管理 - 成本控制量管理列表
  {
    path: 'costControlList',
    name: 'costControlList',
    meta: {
      title: '成本控制量管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['costControlList']
    },
    component: function component() {
      return import('@/pages/operateModule/budgetMenu/costControlList/costControlList');
    }
  }, // 运营管理 - 预算管理 - 成本控制量管理 历史记录
  {
    path: 'costControlHistory',
    name: 'costControlHistory',
    meta: {
      title: '成本控制量管理历史记录',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/budgetMenu/costControlList/costControlHistory');
    }
  }, // 运营管理 - 预算管理 - 成本控制量管理 新增
  {
    path: 'costControlAdd',
    name: 'costControlAdd',
    meta: {
      title: '成本控制量管理新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/budgetMenu/costControlList/costControlAdd');
    }
  }, // 运营管理 - 预算管理 - 成本控制量管理 修改
  {
    path: 'costControlEdit',
    name: 'costControlEdit',
    meta: {
      title: '成本控制量管理修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/budgetMenu/costControlList/costControlEdit');
    }
  }, {
    path: 'creditApplication',
    name: 'creditApplication',
    meta: {
      title: '授信申请',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/budgetMenu/creditList/creditApplication');
    }
  }, // 运营管理 - 询价管理 - 询价单管理
  {
    path: 'enquiryManage',
    name: 'enquiryManage',
    meta: {
      title: '询价单管理',
      hidden: false
    },
    component: function component() {
      return import('@/pages/operateModule/enquiryManageMenu/enquiryManage/enquiryManage');
    }
  }, // 运营管理 - 询价管理 - 询价单管理
  {
    path: 'newEnquiryManage',
    name: 'newEnquiryManage',
    meta: {
      title: '询价单管理',
      hidden: false
    },
    component: function component() {
      return import('@/pages/operateModule/enquiryManageMenu/enquiryManage/newEnquiryManage');
    }
  }, // 运营管理 - 询价管理 - 询价单管理
  {
    path: 'helpPlaceOrder',
    name: 'helpPlaceOrder',
    meta: {
      title: '代客下单',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/enquiryManageMenu/enquiryManage/helpPlaceOrder');
    }
  }, // 运营管理 - 询价管理 - 询价单新增
  {
    path: 'enquiryAdd',
    name: 'enquiryAdd',
    meta: {
      title: '询价单新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/enquiryManageMenu/enquiryManage/enquiryAdd');
    }
  }, // 运营管理 - 询价管理 - 询价单编辑
  {
    path: 'enquiryEdit',
    name: 'enquiryEdit',
    meta: {
      title: '询价单编辑',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/enquiryManageMenu/enquiryManage/enquiryEdit');
    }
  }, // 运营管理 - 询价管理 - 生成订单
  {
    path: 'enquiryCreateOrder',
    name: 'enquiryCreateOrder',
    meta: {
      title: '生成订单',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/enquiryManageMenu/enquiryManage/enquiryCreateOrder');
    }
  }, // 运营管理 - 询价管理 - 生成订单
  {
    path: 'enquiryGenerateOrder',
    name: 'enquiryGenerateOrder',
    meta: {
      title: '生成订单',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/enquiryManageMenu/enquiryManage/enquiryGenerateOrder');
    }
  }, // 运营管理 - 询价管理 - 询价单详情
  {
    path: 'enquiryDetail',
    name: 'enquiryDetail',
    meta: {
      title: '询价单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/enquiryManageMenu/enquiryManage/enquiryDetail');
    }
  }, // 运营管理 - 询价管理 - 询价单管理 - 销售维度 - 查看详情
  {
    path: 'saleEnquiryDetail',
    name: 'saleEnquiryDetail',
    meta: {
      title: '销售维度询价单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/enquiryManageMenu/enquiryManage/saleEnquiryDetail');
    }
  }, // 运营管理 - 询价管理 - 需求变更
  {
    path: 'enquiryEditChange',
    name: 'enquiryEditChange',
    meta: {
      title: '询价单编辑',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/enquiryManageMenu/enquiryManage/enquiryEditChange.vue');
    }
  }, // 运营管理 - 邮寄
  {
    path: 'mailingInformation',
    name: 'mailingInformation',
    meta: {
      title: '录入邮寄信息',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/chargeMenu/dealServiceList/mailingInformation.vue');
    }
  }, // 运营管理 - 邮寄
  {
    path: 'reportForm',
    name: 'reportForm',
    meta: {
      title: '数据总览',
      hidden: false
    },
    component: function component() {
      return import('@/pages/operateModule/reportFormMenu/reportForm.vue');
    }
  }, // 运营管理 - 邮寄
  {
    path: 'orderReportForm',
    name: 'orderReportForm',
    meta: {
      title: '订单报表(旧)',
      hidden: false
    },
    component: function component() {
      return import('@/pages/operateModule/reportFormMenu/orderReportForm.vue');
    }
  }, // 运营管理 - 邮寄
  {
    path: 'dailyOrdersReportForm',
    name: 'dailyOrdersReportForm',
    meta: {
      title: '每日订单情况',
      hidden: false
    },
    component: function component() {
      return import('@/pages/operateModule/reportFormMenu/dailyOrdersReportForm.vue');
    }
  }, //  园区信息维护
  {
    path: 'parkInfoMaintenance',
    name: 'parkInfoMaintenance',
    meta: {
      title: '园区信息维护',
      hidden: false
    },
    component: function component() {
      return import('@/pages/operateModule/parkInfoMaintenanceMenu/parkInfoMaintenance.vue');
    }
  }, //  新增园区信息维护
  {
    path: 'addParkInfoMaintenance',
    name: 'addParkInfoMaintenance',
    meta: {
      title: '新增园区信息',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/parkInfoMaintenanceMenu/addParkInfoMaintenance.vue');
    }
  }, //  产品分类信息维护
  {
    path: 'productClaInfo',
    name: 'productClaInfo',
    meta: {
      title: '产品分类信息维护',
      hidden: false
    },
    component: function component() {
      return import('@/pages/operateModule/productClaInfo/productClaInfo.vue');
    }
  }, //  订单报表（新）
  {
    path: 'newOrderReportForm',
    name: 'newOrderReportForm',
    meta: {
      title: '订单报表（新）',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/reportFormMenu/newOrderReportForm.vue');
    }
  }, // 运营管理 - 预算管理 - 授信管理列表 - 调整授信
  {
    path: 'adjustmentCredit',
    name: 'adjustmentCredit',
    meta: {
      title: '调整授信',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/budgetMenu/newCreditExtension/adjustmentCredit.vue');
    }
  }, // 运营管理 - 预算管理 - 授信管理列表 - 修改授信
  {
    path: 'modificationCredit',
    name: 'modificationCredit',
    meta: {
      title: '修改授信',
      hidden: true
    },
    component: function component() {
      return import('@/pages/operateModule/budgetMenu/newCreditExtension/modificationCredit.vue');
    }
  }, //  ===========预算管理 end  ===============
  // 运营管理-机构用户-客商基本信息管理(重构)
  {
    path: 'lcpMerchantBasicList',
    name: 'lcpMerchantBasicList',
    meta: {
      title: '客商基本信息管理'
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/newMerchantBasicList/merchantBasicList.vue');
    }
  }, // 运营管理-机构用户-客商基本信息管理-详情(重构)
  {
    path: 'newMerchantBasicDetail',
    name: 'newMerchantBasicDetail',
    meta: {
      title: '客商基本信息管理'
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/newMerchantBasicList/merchantBasicDetail.vue');
    }
  }, // 运营管理-机构用户-客商基本信息管理-编辑(重构)
  {
    path: 'newMerchantBasicEdit',
    name: 'newMerchantBasicEdit',
    meta: {
      title: '客商基本信息管理'
    },
    component: function component() {
      return import('@/pages/operateModule/orgUsersMenu/newMerchantBasicList/merchantBasicEdit.vue');
    }
  }]
};